import moment from 'moment';

const formatFromIsoToFrDate = date =>
  moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

const formatFromIsoToFrTime = date => moment(date).format('HH:mm');

const formatFromIsoToFrDateTime = date =>
  moment(date).format('DD/MM/YYYY à HH:mm');

// affiche la date sous la forme:
// mercredi 04 septembre 2019
const humanizeDate = date =>
  moment(date, 'YYYY-MM-DD').format('dddd DD MMMM YYYY');

// converti une date au format YYYY-MM-DD
const formatDate = date => moment(date).format('YYYY-MM-DD');

const formatDateCustom = (date, format) => moment(date).format(format);

const parseDate = date => {
  // parse depuis le format DD/MM/YYYY
  if (!date) return null;

  const splitedDate = date.split('/');
  if (splitedDate.length !== 3) {
    return null;
  }
  if (splitedDate[2].length !== 4) {
    // année non renseignée /!\ peut beuguer en l'an 10 000
    return null;
  }
  const [day, month, year] = splitedDate;

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const getTemporality = date => {
  const today = moment().endOf('day');
  const parsedDate = parseJavaDate(date);
  const dateDiff = today.diff(parsedDate, 'days');

  if (dateDiff === 0) {
    return { code: 'date.aujourdhui' };
  } else if (dateDiff === 1) {
    return { code: 'date.hier' };
  } else {
    return { code: 'date.ilYaNJours', value: [dateDiff] };
  }
};

const formatHour = date => {
  const parsedDate = parseJavaDate(date).toDate();
  return `${parsedDate
    .getHours()
    .toString()
    .padStart(2, '0')}:${parsedDate
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
};

const parseJavaDate = dateString => moment(dateString, 'DD/MM/YYYY HH:mm');

const floatHoursToDuration = float =>
  moment.duration(float, 'hours').toISOString();

const floatMinutesToDuration = float =>
  moment.duration(float, 'minutes').toISOString();

const durationToFloat = duration =>
  Math.round(
    (moment.duration(duration).hours() +
      moment.duration(duration).minutes() / 60) *
      100,
  ) / 100;

export {
  formatFromIsoToFrDateTime,
  formatFromIsoToFrDate,
  parseDate,
  getTemporality,
  formatHour,
  formatDate,
  floatHoursToDuration,
  floatMinutesToDuration,
  durationToFloat,
  humanizeDate,
  formatFromIsoToFrTime,
  formatDateCustom,
};
